import React, {Fragment} from 'react';
import {Layout, Pager, Welcome as Components, Route, Switch} from 'components';
import {usePages} from 'helpers';

export function Router() {
  const { title } = usePages();
  return (
    <Fragment>
      <Layout.Title />
      <Layout.Header justified container="small">
        <h1>{ title }</h1>
        <Pager />
      </Layout.Header>
      <main>
        <Switch>
          <Route path="*/reality-check/" component={Components.RealityCheck} />
          <Route path="*/life-chart/" component={Components.LifeChart} />
          <Route path="*/quiz/intro/" component={Components.Intro} />
          <Route path="*/quiz/:question/" component={Components.Quiz} />
          <Route path="*/score/" component={Components.Score} />
          <Route component={Components.Welcome} />
        </Switch>
      </main>
    </Fragment>
  );
}
